import { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Button,
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import ServiceLevelsForm from './ServiceLevelsForm';
import { TransportationService } from '../../../data/models/transportation-service.model';
import { TransportationAttribute } from '../../../data/models/transportation-attribute.model';
import { PricingModel } from '../../../data/models/pricing-model.model';
import { TransportationAttributeCategory } from '../../../data/models/transportation-attribute-category.model';

interface ServiceLevelDialogProps {
  title: string;
  clientBC: string;
  clientServiceLevels: TransportationService[];
  transportationAttributeCategories: TransportationAttributeCategory[];
  transportationAttributes: TransportationAttribute[];
  pricingModels: PricingModel[];
  serviceLevel?: TransportationService;
  open: boolean;
  close: () => void;
}

export default function ServiceLevelDialog({
  title,
  clientBC,
  clientServiceLevels,
  transportationAttributeCategories,
  transportationAttributes,
  pricingModels,
  serviceLevel,
  open,
  close,
}: ServiceLevelDialogProps) {
  const { t } = useTranslation('common');

  const savingServiceLevel = false;
  const savedServiceLevel = false;

  const formHook = useForm({
    mode: 'onTouched',
    defaultValues: {
      ServiceLevel: '',
      TransportationAttributes: [] as string[],
      PricingPlan: '',
      Params: [],
    },
  });
  const { reset } = formHook;

  useEffect(() => {
    formHook.reset({
      ServiceLevel: serviceLevel ? serviceLevel.transportationServiceUUID : '',
    });
  }, [serviceLevel]);

  useEffect(() => {
    if (clientServiceLevels.length > 0) {
      const selected = serviceLevel?.transportationAttributes.map((ta) =>
        ta.join(':'),
      );
      const curValues = {
        ServiceLevel: serviceLevel?.transportationServiceUUID || '',
        PricingPlan: /*prevValues.PricingPlan ||*/ '',
        TransportationAttributes: selected || [],
        Params: /*prevValues.Params ||*/ [],
      };
      reset(curValues);
    }
  }, [clientServiceLevels, serviceLevel]);

  useEffect(() => {
    if (savedServiceLevel) {
      handleClose();
      // dispatch(clientSlice.setSavedServiceLevel(false));
    }
  }, [savedServiceLevel]);

  const handleSave = (data: any) => {
    // dispatch(clientSlice.setSavedServiceLevel(false));
    // const newServiceLevel: ClientServiceLevel = {
    // };
    // if (serviceLevel) {
    //   dispatch(clientSlice.updateClientServiceLevelAsync(newServiceLevel));
    // } else {
    //   dispatch(clientSlice.addClientServiceLevelAsync(newServiceLevel));
    // }
  };

  const handleClose = () => {
    formHook.reset();
    close();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <ServiceLevelsForm
          disableServiceLevelSelection={!!serviceLevel}
          clientServiceLevels={clientServiceLevels}
          transportationAttributes={transportationAttributes}
          pricingModels={pricingModels}
          formHook={formHook}
        />
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="secondary"
          disabled={savingServiceLevel}
          onClick={handleClose}>
          {t('common.cancel')}
        </Button>
        <Button
          variant="contained"
          color="primary"
          disabled={!formHook.formState.isValid || savingServiceLevel}
          onClick={formHook.handleSubmit(handleSave)}>
          {t('common.ok')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
